import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    DisclosureButton,
} from "@headlessui/react";
import { handleLogout } from "../../apiClient.js"
import { useUser } from "../../context/UserContext.jsx";

function generateInitialsImage(name, surname) {
    const initials = (name[0] || "") + (surname[0] || "");
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // Imposta le dimensioni del canvas
    const size = 80; // Dimensione dell'immagine
    canvas.width = size;
    canvas.height = size;

    // Imposta il colore di sfondo
    context.fillStyle = "#5930B6"; // Colore di sfondo (puoi personalizzarlo)
    context.fillRect(0, 0, size, size);

    // Imposta le proprietà del testo
    context.fillStyle = "#fff"; // Colore del testo
    context.font = "36px Roboto"; // Font e dimensione del testo

    context.textAlign = "center";
    context.textBaseline = "middle";

    // Disegna le iniziali al centro del canvas
    context.fillText(initials, size / 2, size / 2);

    // Ritorna l'URL dell'immagine generata
    return canvas.toDataURL("image/png");
}

function MenuMobile() {
    const { user } = useUser();

    const navigate = useNavigate();

    return (
        <div className="border-t border-gray-200 pb-3 pt-4">
            <div className="flex items-center px-4">
                <div className="flex-shrink-0">
                    <img
                        alt=""
                        src={generateInitialsImage(user.nome, user.cognome)}
                        className="h-10 w-10 rounded-full"
                    />
                </div>
                <div className="ml-3">
                    <div className="text-sm text-gray-800">
                        {user.nome} {user.cognome}
                    </div>
                    <div className="text-xs text-gray-500">
                        <strong>Ruolo: </strong>
                        {user.ruolo}
                    </div>
                </div>
            </div>
            <div className="mt-3 space-y-1">
                <DisclosureButton
                    key="profilo"
                    as="a"
                    onClick={() => navigate("/profilo")}
                    className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                >
                    Profilo
                </DisclosureButton>

                <DisclosureButton
                    key="logout"
                    as="a"
                    onClick={handleLogout}
                    className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                >
                    Esci
                </DisclosureButton>
            </div>
        </div>
    );
}

export { MenuMobile };
